import apiV2 from "api-v2";
import {
  BulkAction,
  CheckDuplicatesResult,
  RfxDocumentRow,
  UpdateRfxDocumentData,
} from "../types/rfx-document.types";

interface ApiListResponse<T> {
  data: T[];
}

interface ApiSingleResponse<T> {
  data: T;
}

export const fetchDocuments = async (rfqId: number): Promise<RfxDocumentRow[]> => {
  const response = await apiV2.get<ApiListResponse<RfxDocumentRow>>(
    `rfq/${rfqId}/documents`
  );
  return response.data.data;
};

export const updateDocument = async (
  rfqId: number,
  docId: number,
  data: UpdateRfxDocumentData
): Promise<RfxDocumentRow> => {
  const response = await apiV2.patch<ApiSingleResponse<RfxDocumentRow>>(
    `rfq/${rfqId}/document/${docId}/update`,
    data
  );
  return response.data.data;
};

export const reorderDocuments = async (
  rfqId: number,
  orderedIds: number[]
): Promise<void> => {
  await apiV2.post(`rfq/${rfqId}/documents/reorder`, {
    ordered_ids: orderedIds,
  });
};

export const bulkAction = async (
  rfqId: number,
  action: BulkAction,
  docIds: number[],
  categoryId?: number
): Promise<void> => {
  await apiV2.post(`rfq/${rfqId}/documents/bulk-action`, {
    action,
    document_ids: docIds,
    ...(categoryId !== undefined ? { category_id: categoryId } : {}),
  });
};

export const checkDuplicates = async (
  rfqId: number,
  fileNames: string[]
): Promise<CheckDuplicatesResult> => {
  const response = await apiV2.post<ApiSingleResponse<CheckDuplicatesResult>>(
    `rfq/${rfqId}/documents/check-duplicates`,
    { file_names: fileNames }
  );
  return response.data.data;
};
